import { Button } from "primereact/button";
import { useCallback, useState } from "react";
import { useAppContext } from "../../../providers/ProviderAppContainer";
import HasRequiredAuthority from "../../dependencies/HasRequiredAuthority";
import ConfirmationWrapper from "../../common/ConfirmationWrapper";
import { AUTHORITIES } from "../../../constants";
import { getReadableDate } from "../../../utils";
import { TEXT_NORMAL, TEXT_SMALL } from "../../../style";
import IconButton from "../../common/IconButton";

export default function ExamPromoDialogContent({
    id,
    content,
    start_date,
    end_date,
    daily,
    frequency,
    active,
    interval,
    redirect_url,
    updatingViewIndex,
    setContents,
    setDialogEditExamPromoDialogContent,
}) {
    const { requestAPI, showToast } = useAppContext();
    const [deleting, setDeleting] = useState();

    const deleteContent = useCallback(() => {
        requestAPI({
            requestPath: `dialog-contents/exams/${id}`,
            requestMethod: "DELETE",
            setLoading: setDeleting,
            parseResponseBody: false,
            onResponseReceieved: (_, responseCode) => {
                if (responseCode === 204) {
                    showToast({ severity: "success", summary: "Deleted", detail: "Dialog Content Deleted", life: 1000 });
                    setContents((prev) => prev.filter((row) => row.id !== id));
                } else {
                    showToast({ severity: "error", summary: "Failed", detail: "Failed To Delete Dialog Content !", life: 2000 });
                }
            },
        });
    }, [id, requestAPI, setContents, showToast]);

    return (
        <div className="flex gap-3 align-items-center border-1 border-gray-300 border-round py-2 px-3 overflow-hidden">
            <img src={content} alt="Promo content" className="w-6rem h-4rem border-round object-fit-cover" />

            <div className="flex flex-column flex-1 gap-1 min-w-0">
                <span className={`${TEXT_NORMAL} font-semibold`}>
                    {getReadableDate({ date: start_date, removeTime: true })} — {getReadableDate({ date: end_date, removeTime: true })}
                </span>
                <span className={`${TEXT_SMALL} text-600`}>
                    {daily ? `Daily max ${frequency}` : `Total max ${frequency}`} · {active ? "Active" : "Inactive"}
                    {interval > 0 ? ` · ${interval}s delay` : ""}
                    {redirect_url ? " · Link set" : ""}
                </span>
            </div>

            {!!updatingViewIndex && <IconButton icon="pi-equals" color="text-indigo-800" />}

            <HasRequiredAuthority requiredAuthority={AUTHORITIES.UPDATE_COURSE}>
                {!updatingViewIndex && (
                    <div className="flex gap-1">
                        <Button
                            icon="pi pi-pencil"
                            rounded
                            outlined
                            severity="info"
                            size="small"
                            onClick={() =>
                                setDialogEditExamPromoDialogContent((prev) => ({
                                    ...prev,
                                    visible: true,
                                    id,
                                    content,
                                    start_date,
                                    end_date,
                                    daily,
                                    frequency,
                                    active,
                                    interval,
                                    redirect_url,
                                }))
                            }
                        />
                        <ConfirmationWrapper action={deleteContent}>
                            <Button icon="pi pi-trash" rounded outlined severity="danger" size="small" loading={deleting} />
                        </ConfirmationWrapper>
                    </div>
                )}
            </HasRequiredAuthority>
        </div>
    );
}
